import TextPaper from './TextPaper'

export * from './TextPaper'
export * from './context'

export default TextPaper
